import SystemApi from '../system/_systemApi';

class CommercialBankAPI extends SystemApi {
    constructor() {
        super();
    }
    controllerName = 'CommercialBanks';
}

export default new CommercialBankAPI();
